import { render, staticRenderFns } from "./CompletedOrderTable.vue?vue&type=template&id=74b841cb"
import script from "./CompletedOrderTable.vue?vue&type=script&lang=js"
export * from "./CompletedOrderTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports